<template>
  <span class="d-inline-flex align-center">
    <v-progress-circular
      v-if="isLoading"
      color="primary"
      indeterminate
      size="20"></v-progress-circular>
    <template v-else>
      <key-value-list variant="list-inline">
        <key-value label="Phone:" :value="assetVisitPhone" />
      </key-value-list>
    </template>
  </span>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue';
import { get } from 'lodash';
import KeyValueList from '@satellite/components/elements/key_value/KeyValueList.vue';
import KeyValue from '@satellite/components/elements/key_value/KeyValue.vue';

export default {
  name: 'AssetVisitPresenter',
  components: {
    KeyValueList,
    KeyValue
  },
  props: {
    assetVisit: {
      type: Object,
      required: true,
      validator(value) {
        return value?.id || value?.phone;
      }
    }
  },
  setup(props) {
    const isLoading = ref(!props.assetVisit?.phone);
    const fetchedAssetVisit = ref(null);

    const fetchAssetVisit = async () => {
      try {
        isLoading.value = true;

        /**
         * TODO: adopt a caching-enabled fetching mechanism
         * like @tanstack/vue-query to avoid the fecthing to happen
         * multiple times?
         */
        const response = await axios.get('asset-visit', {
          params: {
            s: {
              id: props.assetVisit.id
            }
          }
        });

        fetchedAssetVisit.value = get(response, 'data.data.0') ?? null;
      } catch (error) {
        // TODO: add a retry mechanism?
        console.error('Failed to get asset visit information:', error);
      } finally {
        isLoading.value = false;
      }
    };

    const assetVisitPhone = computed(() => {
      return props.assetVisit?.phone ?? fetchedAssetVisit.value?.phone ?? '-';
    });

    const fetchAssetVisitIfNecessary = () => {
      if (
        !props.assetVisit?.phone &&
        props.assetVisit?.id &&
        fetchedAssetVisit.value?.id !== props.assetVisit?.id
      ) {
        fetchAssetVisit();
      }
    };

    watch(
      () => props.assetVisit,
      () => {
        fetchAssetVisitIfNecessary();
      }
    );

    onMounted(() => {
      fetchAssetVisitIfNecessary();
    });

    return {
      isLoading,
      assetVisitPhone
    };
  }
};
</script>

<style scoped></style>
